import React from 'react';
import { connect } from 'react-redux';

import DeleteAccountConfirmModal from './DeleteAccountConfirmModal';

import { selectLoading } from '../../../../redux/auth/deleteAccount/selectors';
import { deleteAccount } from '../../../../redux/auth/deleteAccount/actions';

const DeleteAccountConfirmModalConnected = (props) => <DeleteAccountConfirmModal {...props} />;

const mapStateToProps = (state) => ({
  loading: selectLoading(state),
});

const mapActionsToProps = {
  deleteAccount,
};

export default connect(mapStateToProps, mapActionsToProps)(DeleteAccountConfirmModalConnected);
